import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useStateValue } from '../../state'
import { client } from '../../utils'
import ButterToast, { Cinnamon } from 'butter-toast'

export const CreateInvoiceAccountModal = ({ show, toggle }) => {
  const [, dispatch] = useStateValue()
  const [isLoading, setIsLoading] = useState(false)
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')

  const createNewInvoiceAccount = async () => {
    setIsLoading(true)
    const data = { name: name, description: description }
    try {
      let resp = await client.post(
        '/account/invoice_account_enrollment.create_invoice_account',
        data
      )
      dispatch({
        type: 'setInvoiceAccts',
        payload: resp.data.invoiceAccts,
      })
      toggle(false)
      setTimeout(() => {
        setIsLoading(false)
      }, 200)
    } catch (err) {
      setIsLoading(false)
      toggle(false)
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Error"
            content={`There was an error trying to create the new invoice account. ${err}`}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-exclamation-triangle fa-3x" />}
          />
        ),
      })
    }
  }

  return (
    <Modal show={show} onHide={() => toggle(!show)} className="modal-center">
      <Modal.Header>
        <Modal.Title>Create New Invoice Account</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <div className="d-flex justify-content-center">
            <div
              className="icon icon_spinner10 icon_spin2 spinner LoadingSpinner d-flex justify-content-center mb-4"
              style={{ fontSize: '26pt' }}
            />
          </div>
        ) : (
          <div>
            <div className="mb-3">
              <b>Name:</b>
              <div>
                <input
                  type="text"
                  className="form-control"
                  onChange={e => setName(e.target.value)}
                />
              </div>
            </div>
            <div>
              <b>Description:</b>
              <div>
                <textarea
                  className="form-control"
                  cols="60"
                  rows="3"
                  onChange={e => setDescription(e.target.value)}
                />
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="text-center">
          <button
            onClick={() => {
              toggle(false)
            }}
            className="btn btn-myed btn-default mr-2"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              createNewInvoiceAccount()
            }}
            className="btn btn-myed btn-primary mt-0"
          >
            Submit
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
